var CKM = CKM || Object.create(null);

CKM.Patterns  = [];

CKM.Patterns.getPattern = function()
{
    
    CKM.Patterns.init();
    return CKM.Patterns[Math.floor(Math.random() * 4)];
}

CKM.Patterns.init =  function()
{

    

CKM.Patterns[0] = [
    //  1   2   3   4   5   6   7   8   9   10  11  12  13  14  15
        0,  3,  3,  3,  3,  0,  0,  0,  0,  0,  3,  3,  3,  3,  0,
        0,  3,  0,  0,  3,  3,  2,  2,  2,  3,  3,  0,  0,  3,  0,
        0,  3,  3,  3,  3,  0,  0,  0,  0,  0,  3,  3,  3,  3,  0,
                                                              
        0,  0,  0,  0,  0,  0,  2,  3,  2,  0,  0,  0,  0,  0,  0,
        0,  0,  0,  3,  0,  0,  0,  0,  0,  0,  0,  3,  0,  0,  0,    
        0,  0,  0,  3,  3,  3,  3,  3,  3,  3,  3,  3,  0,  0,  0
];


CKM.Patterns[1] = [
    //  1   2   3   4   5   6   7   8   9   10  11  12  13  14  15
        1,  2,  3,  0,  0,  0,  3,  3,  3,  0,  0,  0,  3,  2,  1,
        3,  2,  1,  0,  3,  3,  3,  3,  3,  3,  3,  0,  1,  2,  3,
        0,  0,  0,  0,  3,  3,  3,  3,  3,  3,  3,  0,  0,  0,  0,
                                                        
        1,  2,  3,  0,  0,  0,  3,  3,  3,  0,  0,  0,  3,  2,  1,
        1,  2,  3,  0,  0,  0,  3,  3,  3,  0,  0,  0,  3,  2,  1,
        1,  2,  3,  0,  0,  0,  3,  3,  3,  0,  0,  0,  3,  2,  1


];

CKM.Patterns[2] = [
    //  1   2   3   4   5   6   7   8   9   10  11  12  13  14  15
        1,  2,  3,  0,  2,  1,  1,  1,  1,  1,  2,  0,  3,  2,  1,
        0,  0,  0,  0,  1,  2,  2,  2,  2,  2,  2,  0,  0,  0,  0,
        1,  2,  3,  0,  1,  2,  3,  3,  3,  2,  1,  0,  3,  2,  1,
        
        1,  2,  3,  0,  1,  2,  3,  3,  3,  2,  1,  0,  3,  2,  1,
        0,  0,  0,  0,  1,  2,  2,  2,  2,  2,  2,  0,  0,  0,  0,
        1,  2,  3,  0,  2,  1,  1,  1,  1,  1,  2,  0,  3,  2,  1
];
        
CKM.Patterns[3] = [
    //  1   2   3   4   5   6   7   8   9   10  11  12  13  14  15
        3,  3,  3,  0,  2,  1,  1,  0,  1,  1,  2,  0,  3,  3,  3,
        2,  2,  2,  0,  1,  2,  1,  1,  1,  2,  1,  0,  2,  2,  2,
        0,  1,  0,  0,  1,  2,  3,  3,  3,  2,  1,  0,  0,  1,  0,
                                                        
        0,  1,  0,  0,  1,  2,  3,  3,  3,  2,  1,  0,  0,  1,  0,
        2,  2,  2,  0,  1,  2,  1,  1,  1,  2,  1,  0,  2,  2,  2,
        3,  3,  3,  0,  2,  1,  1,  0,  1,  1,  2,  0,  3,  3,  3
    
];
  
CKM.Patterns[4] = [
    //  1   2   3   4   5   6   7   8   9   10  11  12  13  14  15
        0,  0,  0,  2,  3,  3,  3,  2,  1,  0,  0,  0,  2,  2,  1,
        0,  1,  2,  2,  3,  3,  3,  2,  1,  1,  0,  3,  3,  2,  0,
        1,  2,  3,  3,  3,  3,  3,  3,  3,  1,  2,  3,  0,  0,  0,
        
        1,  2,  3,  3,  3,  3,  3,  3,  3,  1,  2,  3,  0,  0,  0,
        0,  1,  2,  2,  3,  3,  3,  2,  1,  1,  0,  3,  3,  2,  0,
        0,  0,  0,  2,  3,  3,  3,  2,  1,  0,  0,  0,  2,  2,  1
                                                        
];

}